// import logo from './logo.svg';
import logo from './barekets_image.jpeg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          From 🍁 with ❤️
        </p>
        <a
          className="App-link"
          href="https://www.instagram.com/bareketsarusi/"
          target="_blank"
          rel="noopener noreferrer"
        >
          About Bareket
        </a>
      </header>
    </div>
  );
}

export default App;
